export class CouponTypeFidelityModel {
  public id: string = '';
  public name: string = '';
  public status: string = '';
  public couponsType: Array<any> = [];
}
